const detail = () => {
    document.querySelectorAll('.js-fade-slider').forEach(slider => {

        const images = slider.querySelectorAll('img');
        if (images.length === 0) return;

        let index = 0;

        images[0].classList.add('is-active');

        setInterval(() => {
            images[index].classList.remove('is-active');

            index = (index + 1) % images.length;

            images[index].classList.add('is-active');

        }, 4000); // ← 秒数調整
    });
}

export default detail;
